import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetCallCenterAgentQuery, useGetCallCenterQueueQuery } from "features/call_center/callCenterApiSlice";
import Tabs from "components/UI/Tabs/Tabs";
import QueueAgents from "../Tiers/QueueAgents";
import QueueTiers from "../Tiers/QueueTiers";
import Skeleton from "react-loading-skeleton";

const ViewCenterQueue = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Call Center Queue"));
  }, [dispatch]);

  const { data: callQueue, isLoading } = useGetCallCenterQueueQuery(params?.id);

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible);
  };

  const extensionData = [
    { label: "Name", value: callQueue?.name },
    { label: "Description", value: callQueue?.description },
    { label: "Enabled", value: callQueue?.enabled ? 'Yes' : 'No' },
    { label: "Domain", value: callQueue?.domain?.name || "" },
    { label: "Creted By", value: `${callQueue?.created_by?.firstname} ${callQueue?.created_by.lastname}` },
  ];

  const tabsData = [
    { key: "agents", label: "Queue Agents", content: <QueueAgents label={label} /> },
    { key: "tiers", label: "Queue Tiers", content: <QueueTiers label={label} /> },
  ]

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />

          {isLoading ? (
            <Skeleton />
          ) : (
            <div>
              {/* Button to toggle visibility */}
              <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
                {isEditVisible ? (
                  <RiCloseFill color={Globals.colorRed} size={30} />
                ) : (
                  <>
                    <h3>Edit Call Center Queue </h3>
                    <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                  </>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
      {isLoading ? (
        <Skeleton />
      ) : (
        <Tabs tabs={tabsData} />
      )}
    </>
  )
}

export default ViewCenterQueue